import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FunctionsContext from './FunctionsContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';

const DialogTitleContainer = styled.div`
    width:100%
    display:flex;
    align-items:center;
    justify-content:space-between;
`;

export default function ConfirmArchiveDialog() {
  const context = React.useContext(FunctionsContext);
  const [saving, setSaving] = React.useState(false);


  if (!context.iwppApproverStepToDelete) return null;

  return (

      <Dialog
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
            <DialogTitleContainer>
            <div>Confirm Delete</div>
            {saving && <CircularProgress size={20}/>}
            </DialogTitleContainer>
        </DialogTitle>
        <DialogContent>
         
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this workflow step?
          </DialogContentText>
         
        </DialogContent>
        <DialogActions>
          <Button disabled={saving} onClick={()=>{context.confirmDeleteOfIWPPAprroverStep(null);}} color="primary">
            CANCEL
          </Button>
          <Button  disabled={saving} onClick={()=>{
                setSaving(true)
                context.deleteIWPPApproverStep(context.iwppApproverStepToDelete.id, success => {

                    setSaving(false)

                    if(success)
                    {
                        context.confirmDeleteOfIWPPAprroverStep(null);
                    }
                });


          }} color="primary"
          
          autoFocus>
            DELETE NOW
          </Button>
        </DialogActions>
      </Dialog>
  );
}